const API_CORESERVICE_BASE_URL = 'https://bhada24-main-454042675204.asia-south1.run.app/api';
//const API_MAINSERVICE_BASE_URL = "https://api-main.bhada24.com/api";

//const API_CORESERVICE_BASE_URL = "http://localhost:8081/api";

const API_ENDPOINTS = {
  GET_SP_BY_ID: (id) => `${API_CORESERVICE_BASE_URL}/service-provider/${id}`,
  ADD_USER: `${API_CORESERVICE_BASE_URL}/service-provider/register`,
  DELETE_USER: (id) => `${API_CORESERVICE_BASE_URL}/service-provider/${id}`,
  UPDATE_USER: `${API_CORESERVICE_BASE_URL}/service-provider/update`,
  GET_USER_BY_EMAIL: (email) => `${API_CORESERVICE_BASE_URL}/service-provider/find/email/${email}`,
  GET_USER_BY_MOBILE: (mobile) => `${API_CORESERVICE_BASE_URL}/service-provider/find/${mobile}`,
  DEACTIVATE_SERVICE_PROVIDER: (serviceProviderId) => `${API_CORESERVICE_BASE_URL}/service-provider/deactivate/${serviceProviderId}`,
  UPDATE_SERVICE_PROVIDER_LANGUAGE: (serviceProviderId, language) => `${API_CORESERVICE_BASE_URL}/service-provider/update/language/${serviceProviderId}?language=${encodeURIComponent(language)}`,
  
  UPDATE_NOTIFICATION_SETTINGS: (serviceProviderId, mobile, email) => `${API_CORESERVICE_BASE_URL}/notification/setting/update/${serviceProviderId}?mobile=${mobile}&email=${email}`,

  // Event Service APIs
  ADD_EVENT_SERVICE: `${API_CORESERVICE_BASE_URL}/listing-services/create`,
  UPDATE_EVENT_SERVICE_BY_ID: (esId) => `${API_CORESERVICE_BASE_URL}/listing-services/${esId}`,
  GET_EVENT_SERVICES_BY_SP_ID: (spId) => `${API_CORESERVICE_BASE_URL}/listing-services/sp/${spId}`,
  GET_EVENT_SERVICE_BY_ID: (esId) => `${API_CORESERVICE_BASE_URL}/listing-services/${esId}`,
  DELETE_EVENT_SERVICE_BY_ID: (esId) => `${API_CORESERVICE_BASE_URL}/listing-services/${esId}`,
  UPDATE_ES_BOOKING_STATUS: `${API_CORESERVICE_BASE_URL}/listing-services/bookings/status`,

  // Common service endpoints
  UPLOAD_BASE64_IMAGE: `${API_CORESERVICE_BASE_URL}/common/uploadBase64Image`,

  // FCM Notification endpoints (Backend)
  REGISTER_FCM_TOKEN: `${API_CORESERVICE_BASE_URL}/common/notifications/register-token`,
  UPDATE_FCM_TOKEN: `${API_CORESERVICE_BASE_URL}/common/notifications/update/fcm-token`,
  GET_USER_TOKENS_STATUS: (userId) => `${API_CORESERVICE_BASE_URL}/common/notifications/user/${userId}/tokens/status`,

  ADD_SERVICE_AVAILABILITY_EXCEPTION: (serviceType, serviceId) => `${API_CORESERVICE_BASE_URL}/provider/availability-exceptions/${serviceType}/${serviceId}`,
  GET_AVAILABILITY_EXCEPTIONS: (serviceType, serviceId) => `${API_CORESERVICE_BASE_URL}/provider/availability-exceptions/${serviceType}/${serviceId}`,
  DELETE_AVAILABILITY_EXCEPTION: (exceptionId) => `${API_CORESERVICE_BASE_URL}/provider/availability-exceptions/delete/${exceptionId}`,

  // Service Categories APIs
  GET_ALL_CATEGORIES: `${API_CORESERVICE_BASE_URL}/categories`,
  GET_CATEGORY_BY_ID: (categoryId) => `${API_CORESERVICE_BASE_URL}/categories/${categoryId}`,
  GET_SUBCATEGORIES_BY_CATEGORY_ID: (categoryId) => `${API_CORESERVICE_BASE_URL}/categories/${categoryId}/subcategories`,

  // Membership APIs
  ACTIVATE_FREE_MEMBERSHIP: (spId) => `${API_CORESERVICE_BASE_URL}/membership/activate-free/${spId}`,
  GET_MEMBERSHIP_STATUS: (spId) => `${API_CORESERVICE_BASE_URL}/membership/provider/${spId}`,

  // Provider Ratings APIs
  GET_PROVIDER_AVERAGE_RATING: (spId) => `${API_CORESERVICE_BASE_URL}/provider/ratings/service/${spId}/average`,

  // Leads APIs
  GET_LEADS_BY_SP_ID: (spId) => `${API_CORESERVICE_BASE_URL}/interactions/sp/${spId}/leads`,

  // Validation APIs
  VALIDATE_MOBILE: (mobile) => `${API_CORESERVICE_BASE_URL}/service-provider/validate/${mobile}`,

  // Firebase Realtime Database paths (Frontend)
  FIREBASE_NOTIFICATIONS_PATH: (userId) => `notifications/${userId}`,
  FIREBASE_DATABASE_URL: "https://bhada24-c13f2-default-rtdb.asia-southeast1.firebasedatabase.app/",
};
export default API_ENDPOINTS;